import { useEffect, useState } from 'react';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { bedStatusAPI, systemAPI } from '../../apis';
import { updateLoginInfoAction } from '../../redux/actions';
import { addLoginAction } from '../../utils/check';
import { useQuery } from '../../utils/useQuery';
import rou from '../../router';
import Dialog from '../../components/Dialog';
import { AutoCompleteSelect } from '../../components';
import { LOGIN_INFO } from '../../comm/constant';
import { mutationUpdateOtherLoginInfo } from '../../utils/handleUpdateOtherLoginInfo';
import { updateHospitalWardListAction } from '../../redux/actions/hospitalWardList';
import { updateUserRoleAction } from '../../redux/actions/userRole';
import { CUBICLE_VIEW, CUBICLE_VIEW2 } from '../../redux/constant';

const PAGE_VALUE = {
  HOME: 'home',
  TELEVISIT: 'televisit',
  EHANDOVER: 'ehandover',
  EQUIPMENT: 'equipment',
  DUTYASSIGN: 'dutyassign',
  BEDSTATUS: 'bedstatus',
};

const SSO = () => {
  const query = useQuery();
  const dispatch = useDispatch();
  const history = useHistory();
  const [itemList, setItemList] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedWard, setSelectedWard] = useState('');
  const [tempData, setTempData] = useState({});
  const [errorPopup, setErrorPopup] = useState(false);

  useEffect(() => {
    sessionStorage.setItem('SSO_LOGIN', true);
  }, []);

  const getViewSettingAPI = async ({ wardId }) => {
    try {
      const { result } = await bedStatusAPI.getViewSettingDetail({ wardId });
      if ([CUBICLE_VIEW, CUBICLE_VIEW2].includes(result.viewType)) {
        return rou.bedstatusNewRou.path;
      } else {
        return rou.bedstatusRou.path;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePage = async (pageValue, wardId) => {
    switch (pageValue) {
      case PAGE_VALUE.HOME:
        return rou.homeRou.path;
      case PAGE_VALUE.BEDSTATUS:
        return await getViewSettingAPI({ wardId });
      case PAGE_VALUE.DUTYASSIGN:
        return rou.dutyassignRou.path;
      case PAGE_VALUE.EHANDOVER:
        return rou.ehandoverRou.path;
      case PAGE_VALUE.EQUIPMENT:
        return rou.equipmentRou.path;
      case PAGE_VALUE.TELEVISIT:
        return rou.televisitRou.path;
      default:
        return rou.homeRou.path;
    }
  };

  const getSysUserRole = async (corpId) => {
    try {
      const { result } = await systemAPI.getSysUserRole({ corpId });
      if (Array.isArray(result)) {
        dispatch(updateHospitalWardListAction(null));
        dispatch(updateUserRoleAction(result));
      }
    } catch (error) {}
  };

  const ssoLogin = async ({ hospital, token, userId, wardLocation }) => {
    try {
      const { result } = await systemAPI.ssoLogin({ hospital, token, userId, wardLocation });
      await getSysUserRole(userId);
      const temp = {
        corpID: userId,
        token: result.token,
        refreshToken: result.refreshToken,
        displayName: result.displayName,
        createTime: result.createTime,
        refreshTokenExp: result.refreshTokenExp,
      };
      setTempData(temp);
      if (result.wards.length === 1) {
        const role = {
          hospitalId: result.wards[0]?.hospId ?? null,
          hospitalName: result.wards[0]?.hospitalName ?? null,
          userId: result.wards[0]?.userId ?? null,
          wardId: result.wards[0]?.wardId ?? null,
          wardName: result.wards[0]?.wardName ?? null,
        };

        dispatch(
          updateLoginInfoAction({
            ...temp,
            ...role,
            flag: true,
          })
        );
        localStorage.setItem(
          LOGIN_INFO,
          JSON.stringify({
            ...temp,
            ...role,
            flag: true,
          })
        );
        addLoginAction();

        const page = await handlePage(query.page, role.wardId);
        setTimeout(() => {
          mutationUpdateOtherLoginInfo();
          history.push(page);
        }, 100);
      } else {
        setItemList(
          _.map(result.wards, (item) => ({
            value: item.wardId,
            text: item.wardName,
            data: item,
          }))
        );
        setShowDialog(true);
      }
    } catch (error) {
      setErrorPopup(true);
      console.log(error);
    }
  };

  useEffect(() => {
    ssoLogin({
      hospital: query.hosp,
      token: query.Token,
      userId: query.user_id,
      wardLocation: query.ward_loc,
    });
  }, [query]);

  const handleSelectWard = async () => {
    try {
      const selected = _.find(itemList, (item) => item.value === selectedWard)?.data;
      const role = {
        hospitalId: selected?.hospId ?? null,
        hospitalName: selected?.hospitalName ?? null,
        userId: selected?.userId ?? null,
        wardId: selected?.wardId ?? null,
        wardName: selected?.wardName ?? null,
      };
      dispatch(
        updateLoginInfoAction({
          ...tempData,
          ...role,
          flag: true,
        })
      );
      localStorage.setItem(
        LOGIN_INFO,
        JSON.stringify({
          ...tempData,
          ...role,
          flag: true,
        })
      );
      addLoginAction();

      const page = await handlePage(query.page);
      setTimeout(() => {
        mutationUpdateOtherLoginInfo();
        history.push(page);
      }, 100);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      {showDialog && (
        <Dialog open={true} haveClose={false} title="Select Ward" confirm="Confirm" handleConfirm={handleSelectWard}>
          <AutoCompleteSelect itemList={itemList} value={selectedWard} onChange={setSelectedWard} />
        </Dialog>
      )}
      {errorPopup && (
        <Dialog open={true} haveClose={false} title="Error" confirm="Confirm" handleConfirm={() => window.close()}>
          {`The Ward Place session is expired. Kindly close this popup/window, refresh the original system's window and
          click the Ward Place button/linkage again.`}
        </Dialog>
      )}
    </div>
  );
};

export default SSO;
